jQuery(document).ready(function ($) {

	/**
	 * Tabs for the moving system/ accessory Pages
	 */

	// NEED to change this to a for each tabbed section and use a class, so that I can repeat this section and it will be fine.

	if ($('#tabbed-section').length > 0) {
		$('.tabs-title').first().click()
	}
	if ($('#tabbed-section-2').length > 0) {
		$('#tabbed-section-2 .tabs-title').first().click()
	}
});
